import gsap from 'gsap';

const ITEM_SELECTOR = ':scope > .accordion-item, :scope > .wp-block-foxfuel-accordion-item';
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const getItems = (accordion) => [
    ...accordion.querySelectorAll(ITEM_SELECTOR),
];

const getTrigger = (item) => item.querySelector('.accordion-item__trigger');
const getPanel = (item) => item.querySelector('.accordion-item__panel');

const prefersReducedMotion = () => (
    window.matchMedia(REDUCED_MOTION_QUERY).matches
);

const clearPanelProps = (panel) => {
    gsap.set(panel, {
        clearProps: 'height,opacity,overflow',
    });
};

const openPanelInstantly = (panel) => {
    panel.hidden = false;
    clearPanelProps(panel);
};

const closePanelInstantly = (panel) => {
    panel.hidden = true;
    clearPanelProps(panel);
};

const animateOpenPanel = (panel) => {
    panel.hidden = false;
    gsap.killTweensOf(panel);
    gsap.set(panel, {
        height: 'auto',
        overflow: 'hidden',
    });

    const targetHeight = panel.offsetHeight;

    gsap.fromTo(
        panel,
        {
            height: 0,
            opacity: 0,
        },
        {
            duration: 0.28,
            ease: 'power2.out',
            height: targetHeight,
            opacity: 1,
            onComplete: () => clearPanelProps(panel),
        }
    );
};

const animateClosePanel = (panel) => {
    gsap.killTweensOf(panel);
    gsap.set(panel, {
        height: panel.offsetHeight,
        overflow: 'hidden',
    });

    gsap.to(panel, {
        duration: 0.24,
        ease: 'power2.inOut',
        height: 0,
        opacity: 0,
        onComplete: () => closePanelInstantly(panel),
    });
};

const setItemOpen = (item, isOpen, shouldAnimate = true) => {
    const trigger = getTrigger(item);
    const panel = getPanel(item);

    if (!trigger || !panel) {
        return;
    }

    if (!isOpen && panel.hidden) {
        trigger.setAttribute('aria-expanded', 'false');
        closePanelInstantly(panel);
        return;
    }

    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (!shouldAnimate || prefersReducedMotion()) {
        if (isOpen) {
            openPanelInstantly(panel);
            return;
        }

        closePanelInstantly(panel);
        return;
    }

    if (isOpen) {
        animateOpenPanel(panel);
        return;
    }

    animateClosePanel(panel);
};

const initializeAccordion = (accordion) => {
    const items = getItems(accordion);
    const allowMultiple = accordion.dataset.allowMultiple === 'true';

    items.forEach((item) => {
        const trigger = getTrigger(item);

        if (!trigger) {
            return;
        }

        trigger.addEventListener('click', () => {
            const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';

            if (shouldOpen && !allowMultiple) {
                items.forEach((sibling) => {
                    if (sibling !== item) {
                        setItemOpen(sibling, false);
                    }
                });
            }

            setItemOpen(item, shouldOpen);
        });
    });
};

const initialize = () => {
    document.querySelectorAll('.accordion').forEach(initializeAccordion);
};

export default {
    initialize,
};
